var map = {
	"./decidim/avatar-multiuser.png": 49512,
	"./decidim/brands/facebook.svg": 13622,
	"./decidim/brands/google.svg": 23255,
	"./decidim/brands/twitter-x.svg": 20124,
	"./decidim/cc-badge.png": 82306,
	"./decidim/decidim-logo.svg": 6474,
	"./decidim/default-avatar.svg": 65590,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 28458,
	"./decidim/icons.svg": 23353,
	"./decidim/pattern.png": 25782,
	"./decidim/placeholder-card-g.svg": 60667,
	"./decidim/placeholder-card-l.svg": 26992,
	"./decidim/placeholder.jpg": 69975,
	"./decidim/remixicon.symbol.svg": 42639,
	"./decidim/vendor/social-share-button/douban.svg": 83838,
	"./decidim/vendor/social-share-button/email.svg": 25531,
	"./decidim/vendor/social-share-button/facebook.svg": 67869,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3143,
	"./decidim/vendor/social-share-button/hacker_news.svg": 18847,
	"./decidim/vendor/social-share-button/linkedin.svg": 63107,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 39052,
	"./decidim/vendor/social-share-button/pinterest.svg": 35661,
	"./decidim/vendor/social-share-button/reddit.svg": 72797,
	"./decidim/vendor/social-share-button/telegram.svg": 79716,
	"./decidim/vendor/social-share-button/tumblr.svg": 32555,
	"./decidim/vendor/social-share-button/twitter.svg": 69434,
	"./decidim/vendor/social-share-button/vkontakte.svg": 26020,
	"./decidim/vendor/social-share-button/wechat.svg": 85087,
	"./decidim/vendor/social-share-button/whatsapp.svg": 37215,
	"./decidim/vendor/social-share-button/x.svg": 44891,
	"./decidim/vendor/social-share-button/xing.svg": 77421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29159;